require('./sentiment-feedback-form.scss');
var tracking = require('./sentiment-tracking.js');

window.EDM || (window.EDM = {});
var EDM = window.EDM;
EDM.SentimentWidget || (EDM.SentimentWidget =
{
    smileyData: [
        { name: 'good', value: 1 },
        { name: 'neutral', value: 5 },
        { name: 'bad', value: 9 }
    ]
});

EDM.SentimentWidget.FeedbackForm = function() {
    var _sentimentName, _feedbackFormEle, _formEle, _sendBtnEle, _textArea,
        _sentimentContainer, _thankYouPageEle, _currentIdx = -1;

    function _userInputHandler() {
        if (_textArea.value.length <= 0) {
            _sendBtnEle.setAttribute('disabled', true);
        } else {
            _sendBtnEle.removeAttribute('disabled');
            _sendBtnEle.setAttribute('data-link-click',
                JSON.stringify(tracking.makeFeedbackPixel(
                    _sentimentName,
                    _currentIdx,
                    _textArea.value)));
        }
    }

    function _sendButtonClickHandler() {
        // if (_textArea.value.length <= 0) {
        //     e.preventDefault();
        //     return;
        // }
        // _sendBtnEle.setAttribute('data-link-click',
        //     JSON.stringify(tracking.makeFeedbackPixel(
        //         _sentimentName,
        //         _currentIdx,
        //         _textArea.value)));
        _showThankYouPage();
    }

    function _sentimentClickHandler(e) {
        var target = e.target || e.srcElement;
        if (!target.classList.contains('sentiment-icon')) {
            return;
        }
        var idx = _findClickedIndex(target.parentElement);
        _updatePlaceholder(idx);
    }

    function _showThankYouPage() {
        _formEle.querySelector('.top-area').classList.add('collapse');
        _formEle.querySelector('.bottom-area').classList.add('collapse');
        _thankYouPageEle.classList.remove('collapse');
    }

    function _findClickedIndex(target) {
        return Array.prototype.indexOf.call(_sentimentContainer.children, target);
    }

    function _generateText(word) {
        return 'You rated your experience on this page as "' + word + '"! Tell us why.';
    }

    
    function _updatePlaceholder(idx) {
        _currentIdx = idx;
        _textArea.setAttribute('placeholder', _generateText(EDM.SentimentWidget.smileyData[idx].name));
    }

    return {
        openForm: function(name, rating){
            _sentimentName = name;

            var _smileyContainer = document.querySelector('.bottom-area .smiley-area .sentiment-link-area');
            try {
                EDM.SentimentWidget.smileyData[rating].value > 0; // try to access out of bounds
            } catch(e) {
                rating = 0;
            }
            _smileyContainer.classList.add(EDM.SentimentWidget.smileyData[rating].name);
            _feedbackFormEle = $('#sentimentFeedbackForm');
            _feedbackFormEle.modal && _feedbackFormEle.modal('show');

            _formEle = _feedbackFormEle[0];

            _sendBtnEle = _formEle.querySelector('.send-btn');
            _textArea = _formEle.querySelector('textarea.user-input');
            _sentimentContainer = _formEle.querySelector('.sentiment-link-area');
            _thankYouPageEle = _formEle.querySelector('.thank-you-page');

            _textArea.addEventListener('keyup', _userInputHandler);
            _sendBtnEle.addEventListener('click', _sendButtonClickHandler);
            _sentimentContainer.addEventListener('click', _sentimentClickHandler);

            _updatePlaceholder(rating);
        }
    };
}();






//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/sentiment-widget/sentiment-feedback-form.js
// module id = 247
// module chunks = 0 1